import { render, staticRenderFns } from "./newAdd.vue?vue&type=template&id=b14f1176&scoped=true"
import script from "./newAdd.vue?vue&type=script&lang=js"
export * from "./newAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14f1176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b14f1176')) {
      api.createRecord('b14f1176', component.options)
    } else {
      api.reload('b14f1176', component.options)
    }
    module.hot.accept("./newAdd.vue?vue&type=template&id=b14f1176&scoped=true", function () {
      api.rerender('b14f1176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicData/employeesNumber/component/newAdd.vue"
export default component.exports